import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    const glossaryHeader = document.getElementById("glossaryHeader");

    const observer = new IntersectionObserver(
      ([e]) => {
        ["tw-border-b", "tw-border-gray-200", "dark:tw-border-moon-700", "tw-shadow-[rgba(0,0,0,0.1)_0px_1px_0px_0px]"].map(tailwindClass => e.target.classList.toggle(tailwindClass, e.intersectionRatio < 1));
      },
      { threshold: [1] }
    );

    observer.observe(glossaryHeader);
  }

  jump(e) {
    const element = document.getElementById(e.target.innerText);

    if (element === null) return;

    let headerOffset = 60;
    let elementPosition = element.getBoundingClientRect().top;
    let offsetPosition = elementPosition + window.scrollY - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }
}
